module.exports = __webpack_public_path__ + "img/_Shadow.004d0228.png";